import { render } from "./DetailMasterCategory.vue?vue&type=template&id=abd21c3c&scoped=true"
import script from "./DetailMasterCategory.vue?vue&type=script&lang=js"
export * from "./DetailMasterCategory.vue?vue&type=script&lang=js"

import "./DetailMasterCategory.vue?vue&type=style&index=0&id=abd21c3c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abd21c3c"]])

export default __exports__